/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Canceled_End_AtInputs */

const en_settings_billing_canceled_end_at = /** @type {(inputs: Settings_Billing_Canceled_End_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ends at`)
};

const zh_settings_billing_canceled_end_at = /** @type {(inputs: Settings_Billing_Canceled_End_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结束时间`)
};

/**
* | output |
* | --- |
* | "Ends at" |
*
* @param {Settings_Billing_Canceled_End_AtInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_canceled_end_at = /** @type {((inputs?: Settings_Billing_Canceled_End_AtInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Canceled_End_AtInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_canceled_end_at(inputs)
	return zh_settings_billing_canceled_end_at(inputs)
});
export { settings_billing_canceled_end_at as "settings.billing.canceled_end_at" }